module.exports = __webpack_public_path__ + "static/img/3.57e5b2cf.jpg";